import { TitlePage } from "@components/commun";
import { Content } from "@prismicio/client";
import { PrismicRichText } from "@prismicio/react";
import Image from "next/image";
import { FC } from "react";
import { ICountry } from "@middleware/types";
import style from "./Pedagogique.module.scss";
import { BilanContainer } from "../bilan/BilanContainer/BilanContainer";

interface PedagogiqueProps {
  page: Content.PedagogiqueDocument;
  bilan: Content.PageBilanDocument;
  countries: ICountry[];
}

const Pedagogique: FC<PedagogiqueProps> = ({ page, bilan, countries }) => {
  return (
    <div className={style.cms}>
      <div className="lk-wrap large">
        <div className={style.wrapper}>
          <div>
            <TitlePage className={style.title}>
              <PrismicRichText field={page.data.title} />
            </TitlePage>
          </div>
          <div className={style.image}>
            <Image
              src={page.data.image.url ?? ""}
              alt={page.data.image.alt ?? ""}
              width={page.data.image.dimensions?.width}
              height={page.data.image.dimensions?.width}
            />
          </div>
          <div className={style.text}>
            <PrismicRichText field={page.data.text} />
          </div>
        </div>
      </div>
      <BilanContainer
        phoneIsRequired={page.data.phone_required.valueOf()}
        content={bilan}
        countries={countries}
      />
    </div>
  );
};

export default Pedagogique;
